const HEADER_NAMES = {
  default: 'Featured Looks',
  wedding: 'Wedding Guest Looks',
  theory: 'Theory Looks',
  home: 'Pair it With',
  // ralphLauren = 'Ralph Lauren Looks'
};

const API_DEFAULT_CONFIG = {
  api: {
    tags: '',
    max: 6,
    min: 2,
  },
};

const WIDGET_NAMES = {
  MOODBOARD: 'moodboard',
  HOTSPOTS: 'hotspots',
  CLASSIC: 'classic',
};

const LAYOUT_DEFAULT_CONFIG = {
  text: {
    itemLinkCTA: 'SHOP NOW',
  },
  display: {
    swipeableCarouselDots: true,
    disableMnM: true,
    swipeableCarouselNextItemPeek: 0,
  },
};

const CONFIG = {
  accountName: 'bloomingdales-women',
  moodboardAccountName: 'bloomingdales',
  categories: {
    2910: {
      tagName: 'womenscat_gallery',
      header: HEADER_NAMES.default,
    },
    3864: {
      tagName: 'menscat_gallery',
      header: HEADER_NAMES.default,
    },
    16958: {
      tagName: 'handbagscat_gallery',
      header: HEADER_NAMES.default,
    },
    16961: {
      tagName: 'shoescat_gallery',
      header: HEADER_NAMES.default,
    },
    3376: {
      tagName: 'jacat_gallery',
      header: HEADER_NAMES.default,
    },
    3948: {
      tagName: 'giftcat_gallery',
      header: HEADER_NAMES.default,
    },
    1003152: {
      tagName: 'mens_weddingguest_gallery, womens_weddingguest_gallery',
      header: HEADER_NAMES.wedding,
    },
    1002845: {
      tagName: 'mens_theory_gallery, womens_theory_gallery',
      header: HEADER_NAMES.theory,
    },
    1002851: {
      tagName: 'aquacat_gallery',
      header: HEADER_NAMES.default,
    },
    1193259: {
      tagName: 'shopstyle_gallery',
      header: HEADER_NAMES.home,
    },
    // 1003114: 'mens_ralphlauren_gallery , womens_ralphlauren_gallery',
  },

  moodboardCategories: [
    '1193259',
  ],

  categoryProperties: {
    handbagscat_gallery: ['Bags', 'category'],
    shoescat_gallery: ['Shoes', 'other_client_item_ids.department'],
    jacat_gallery: ['Jewelry', 'other_client_item_ids.department'],
  },

  // Change value for particular cat id to change widget header name
  mapCatIdToHeaderName: {
    2910: HEADER_NAMES.default,
    3864: HEADER_NAMES.default,
    16958: HEADER_NAMES.default,
    16961: HEADER_NAMES.default,
    3376: HEADER_NAMES.default,
    3948: HEADER_NAMES.default,
    1002851: HEADER_NAMES.default,
    1193259: HEADER_NAMES.home,
    1003152: HEADER_NAMES.wedding,
    1002845: HEADER_NAMES.theory,
    // 1003114: HEADER_NAMES.ralphLauren,
  },

  layoutSettings: {
    [WIDGET_NAMES.CLASSIC]: {
      api: {
        ...API_DEFAULT_CONFIG.api,
      },
      display: {
        ...LAYOUT_DEFAULT_CONFIG.display,
        clickableCarouselGutterWidth: 0,
        swipeableCarouselGutterWidth: 0,
        swipeableCarouselLeftPadding: 0,
      },
      text: {
        ...LAYOUT_DEFAULT_CONFIG.text,
      },
      responsive: [
        [0, { columns: 1 }],
        [720, { columns: 2 }], // container size when screen is 1024
      ],
    },
    [WIDGET_NAMES.MOODBOARD]: {
      api: {
        ...API_DEFAULT_CONFIG.api,
        min: 2,
      },
      display: {
        ...LAYOUT_DEFAULT_CONFIG.display,
        clickableCarouselDots: true,
        bundleBackgroundColor: '#fff',
        hideAnchorItemCard: true,
        bundleCounter: false,
        moodboardImageType: 'non-editorial',
        coerceMoodboardImageAspectRatio: 'square',
        maxGridSize: 7,
      },
      text: {
        ...LAYOUT_DEFAULT_CONFIG.text,
        itemDetailsModalHeader: 'Pair it With',
      },

    },
  },
};

export {
  CONFIG,
  WIDGET_NAMES,
};
